import { getFormattedDate } from "@/utils/Common";
import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Link from "next/link";

const IndividualInsightsFirstSectionInner = ({
  data,
  similarMarketInsights,
}) => {
  return (
    <div className="w-full md:w-[80%]">
      {data?.type === "blogs" && (
        <>
          <div className="flex items-center mb-6 md:mb-20">
            <div className="bg-[#666666] w-10 h-[1px] mr-4"></div>
            <p className="text-[#666666] text-[0.8rem] ">
              {getFormattedDate(data?.created_at)}
            </p>
          </div>
          <div className="bg-[#F1F2F299] py-8 px-6 rounded">
            <p className="text-[1rem] font-medium mb-3">
              {data?.authorName ? data?.authorName : "Author"}
            </p>
            <p className="text-[#666666] text-[0.88rem] mb-8 md:mb-10">
              {data?.authorBio}
            </p>
            <div className="bg-[#666666] w-[100%] h-[1px] mb-6"></div>
            <div className="flex items-center ">
              <a href={data?.authorInstaLink} target="_blank">
                <InstagramIcon className="text-[#666666]" />
              </a>
              <a href={data?.authorLinkedinLink} target="_blank">
                <LinkedInIcon className="text-[#666666] ml-3" />
              </a>
              <a href={data?.authorTwitterLink} target="_blank">
                <TwitterIcon className="text-[#666666] ml-3" />
              </a>
            </div>
          </div>
        </>
      )}
      {data?.type === "events" && (
        <>
          <p className="font-medium text-[#333333] text-[1.1rem] md:text-[1rem]">
            Event Details
          </p>
          <div className="bg-[#F1F2F299] py-8 px-6 rounded mt-4 sm:mt-8">
            {data?.dateOfEvent && (
              <div className="flex border-b border-black border-dotted pb-8">
                <AccessTimeIcon className="text-red text-[1.3rem] mr-4" />
                <div>
                  <p className="text-[1rem] font-medium text-[#333333]">
                    {getFormattedDate(data?.dateOfEvent)}
                  </p>
                  {data?.startTime && (
                    <p className="text-[#666666] text-[0.9rem] mt-1">
                      The event will start from {data?.startTime} to{" "}
                      {data?.endTime ? data?.endTime : "00:00"}
                    </p>
                  )}
                </div>
              </div>
            )}
            {/* <div className="bg-[#666666] w-full h-[1px] my-8"></div> */}

            <div className="flex mt-8">
              <LocationOnOutlinedIcon className="text-red text-[1.4rem] mr-4 -ml-1" />
              <div>
                <p className="text-[1rem] font-medium text-[#333333]">
                  {data?.buildingName}
                  {data?.buildingName ? "," : " "} {data?.city}
                </p>
                <p className="text-[#666666] text-[0.9rem] mt-1">
                  {data?.locality}
                  {data?.locality ? "," : ""}
                  {data?.city}
                  {data?.city ? "," : ""}
                  {data?.state}
                  {data?.state ? "," : ""} {data?.country}
                </p>
                {data?.locationUrl && (
                  <p className="mt-8 text-red cursor-pointer text-[0.9rem] font-medium ">
                    <a href={data?.locationUrl} target="_blank">
                      View On Maps{" "}
                      <KeyboardBackspaceIcon className="rotate-180 text-[1.2rem] ml-1" />
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {data?.type === "market insights" && (
        <>
          <div className="flex items-center gap-2">
            <p className="font-medium text-[#333333] text-[1rem]">
              News Summary
            </p>
            <KeyboardBackspaceIcon className="text-[#333333] text-[1.2rem] rotate-180 font-medium" />
          </div>
          <div className="bg-[#F1F2F2] py-8 px-6 rounded mt-4">
            {data?.summaries?.map((data) => {
              return (
                <>
                  <div className=" flex items-center py-1 border-b-2">
                    <div className="h-1 w-1 bg-black rounded-lg mx-2 font-mukta font-medium"></div>
                    <p className="font-mukta font-medium text-[1rem]">
                      {data?.summaryTitle}
                    </p>
                  </div>
                  <p className="text-[#666666] text-[0.9rem] mt-3 mb-8 ">
                    {data?.summary}
                  </p>
                </>
              );
            })}
          </div>
          {similarMarketInsights?.length > 0 && (
            <>
              <div className="flex items-center gap-2 mt-14">
                <p className="font-medium text-[#333333] text-[1rem]">
                  Similar Insights
                </p>
                <ArrowForwardIcon className="text-[#333333] text-[1rem]" />
              </div>
              <div className=" mt-4">
                {similarMarketInsights?.map((data, index) => {
                  return (
                    <Link
                      href={`/market-insights/${data?.slug}-${data?.id}`}
                      key={index}
                    >
                      <div className="flex gap-4 py-4 h-[6rem] border-b-2">
                        <img
                          src={data?.thumbnailImgUrl}
                          alt={`Thumbnail Image`}
                          className="w-[30%] object-cover rounded"
                        />
                        <p className="text-[0.9rem] text-[#333333] font-medium hideLongTypography2">
                          {data?.title.length > 50
                            ? data?.title.slice(0, 50) + "..."
                            : data?.title}
                        </p>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default IndividualInsightsFirstSectionInner;
